import React from 'react'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'

import type { StyleClasses } from '../styles'

import type { DialogProps } from '../components/Dialog'
import Dialog, { DialogActions, DialogContent, DialogTitle } from '../components/Dialog'
import Button from '../components/Button'
import Typography from '../components/Typography'
import { LeaderboardTrophyIcon } from '../icons'

const useStyles = makeStyles<Theme, LeaderboardConfirmationDialogProps>(
  (theme) => ({
    root: {},
    dialogTitle: {
      backgroundColor: theme.paintscout.palette.primary,
      fontSize: '2rem',
      color: theme.palette.common.white,
      padding: theme.spacing(1.5, 4)
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '1.1rem'
    },
    textTitle: {
      marginBottom: theme.spacing()
    },
    leaderboardsIcon: {
      width: 30,
      marginRight: theme.spacing(2)
    },
    dialogContent: {
      padding: theme.spacing(4)
    },
    cancel: {},
    confirm: {
      background: theme.paintscout.palette.primary,
      color: theme.palette.common.white,
      '&:hover': {
        background: theme.paintscout.palette.dark
      }
    }
  }),
  { name: 'LeaderboardConfirmationDialog' }
)

export interface LeaderboardConfirmationDialogProps extends DialogProps {
  classes?: DialogProps['classes'] & StyleClasses<typeof useStyles>
  title: string
  message: string
  onConfirm: () => any
}

export function LeaderboardConfirmationDialog(props: LeaderboardConfirmationDialogProps) {
  const classes = useStyles(props)
  const { onConfirm, ...baseDialogProps } = props

  return (
    <Dialog {...baseDialogProps}>
      <DialogTitle classes={{ root: classes.dialogTitle }}>
        <Typography variant="body1" className={classes.title}>
          <LeaderboardTrophyIcon className={classes.leaderboardsIcon} />
          Leaderboards
        </Typography>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <Typography variant="h3" weight={'bold'} className={classes.textTitle}>
          {props.title}
        </Typography>
        <Typography variant="body1">{props.message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button className={classes.confirm} variant={'contained'} onClick={onConfirm}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
